module.exports = __webpack_public_path__ + "path.b90a3040524c6dd75650.svg";


//////////////////
// WEBPACK FOOTER
// /var/www/borneo/prod/borneo_app/src/assets/vcg/img/path.svg
// module id = ../../../../../src/assets/vcg/img/path.svg
// module chunks = styles